import RandomWord from '../data/RandomWord';
import { useEffect , useState } from 'react';
import {useFetch} from '../hooks/useFetch'

import '../styles/Rearrange.css'
import Enter from '../img/enter.png'

export default function Rearrange() {
    const shuffle = str => [...str].sort(()=>Math.random()-.5).join(''); 

    const [inputTxt , setInputTxt] = useState('')
    const [word , setWord] = useState('');
    const {data : wordInfo , loading } = useFetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`)

    const [shuffledWord , setShuffledWord] = useState('')

    const [hint1 , setHint1] = useState(false)
    const [hint2 , setHint2] = useState(false)

    const [gameOver , setGameOver ] = useState(false)

    const [score , setScore ] = useState(0);
    

    useEffect(()=> {
      const rWord = RandomWord()
      setWord(rWord) 
      setShuffledWord(shuffle(rWord))

    } , [])


      const handleSubmit = (e) => {
      e.preventDefault();
      if(inputTxt) {
          setInputTxt('')

          if(inputTxt === wordInfo[0].word) {
            const rWord = RandomWord()
            setWord(rWord) 
            setShuffledWord(shuffle(rWord))
            setHint1(false)
            setHint2(false)
            setScore(score + 1);
          }
          else {
            setGameOver(true)
          }
      }

    }

  return (

    <div className='Rearrange'>
      <h1>Re arrange</h1>
      <div className='Rearrange-container'>
        {wordInfo && !gameOver &&  
          <>
            <h1 className="shuffledWord-1">
              {shuffledWord && shuffledWord}
            </h1>
            <h3 className='score-1'>score : {score} </h3>
            <form onSubmit={(e) => handleSubmit(e)} className='ans-1'>
                <input type='text'  
                      value={inputTxt} 
                      onChange={(e) => {
                        setInputTxt(e.target.value.trim().toLowerCase())
                    }}>
                </input>
                <button type='submit'>
                  <img src={Enter} alt="" />
                </button>
              </form>
              <div className='hints-1'>
              <div>
                <span onClick={()=> setHint1(!hint1)}>Hint 1</span>
                {hint1 && 
                <p>
                Parts of Speech : {wordInfo && wordInfo[0].meanings[0].partOfSpeech}
                </p>}
              </div>
              <div>
                <span onClick={()=> setHint2(!hint2)}>Hint 2</span>
                {hint2 &&
                 <p>
                Defination : {wordInfo && wordInfo[0].meanings[0].definitions[0].definition}
                </p>}
                
              </div>
              
            </div>
              
          </>}

          {gameOver && 
          <div className='gameover-1'>
            <h1>Gameover :( </h1>
            <h3>score : {score}</h3>
            <p className='gameover-txt'>Given Word : <span>{shuffledWord}</span> {'&'} Correct : <span>{word}</span></p>
            <p> [{wordInfo && wordInfo[0].meanings[0].partOfSpeech}]
              {wordInfo && wordInfo[0].meanings[0].definitions[0].definition}
            </p>
            <button onClick={()=>  window.location.reload()}>
              try again
            </button>
          </div>}
      </div>
    </div>
  )
}

